/**
 *
 * Asynchronously loads the component for LinkedinShareButton
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/components/linkedin-share-button/loadable.js